import { USER_LANGUAGES_BY_ID } from 'app/constants/enums/Language';
import { isStringIndexable } from 'app/constants/schemas/utils';
import { TEACHING_SKILLS_BY_ID } from 'app/constants/TeachingSkills';
import createErrorType from 'app/utils/createErrorType';
import { decodeOrThrow } from 'app/utils/ioTs';
import { Map } from 'immutable';
import * as t from 'io-ts';

export class InvalidTeachingSkillError extends createErrorType('InvalidTeachingSkillError') {}

export class TeachingSkills {
  public constructor(public readonly data: Map<string, string[]>) {}

  public toJSON() {
    return this.data;
  }
}

const isValidTeachingSkills = (o: {[index: string]: unknown}): o is {[index: string]: string[]} => {
  if (isStringIndexable(o)) {
    Object.keys(o).forEach((key: string) => {
      const value: unknown = o[key];
      if (USER_LANGUAGES_BY_ID.get(key) === undefined) {
        throw new InvalidTeachingSkillError(`Invalid language ${key}`);
      }
      if (!Array.isArray(value)) {
        throw new InvalidTeachingSkillError(`Invalid teaching skill, not an array`);
      }
      for (const i in value) {
        if (value.hasOwnProperty(i)) {
          const skill = value[i];
          if (TEACHING_SKILLS_BY_ID.get(skill) === undefined) {
            throw new InvalidTeachingSkillError(`Invalid teaching skill ${skill}`);
          }
        }
      }
    });
    return true;
  } else {
    return false;
  }
};

const TeachingSkillsMarshallerType = new t.Type<TeachingSkills, Map<string, string[]>, unknown>(
  'TeachingSkillsMarshallerType',
  (u: unknown): u is TeachingSkills => u instanceof TeachingSkills,
  (o, c) => {
    if (isStringIndexable(o) && isValidTeachingSkills(o)) {
      return t.success(new TeachingSkills(Map<string, string[]>(o)));
    } else {
      return t.failure(o, c);
    }
  },
  (a: TeachingSkills) => a.toJSON(),
);

export const TeachingSkillsMarshaller = {
  deserialize: (o: unknown): TeachingSkills => {
    return decodeOrThrow(TeachingSkillsMarshallerType, o, (errors) => {
      throw new InvalidTeachingSkillError(errors.join('\n'));
    });
  },
  serialize: TeachingSkillsMarshallerType.encode,
};
